import { render, staticRenderFns } from "./LeaderboardInfo.vue?vue&type=template&id=1271a3da&scoped=true"
import script from "./LeaderboardInfo.vue?vue&type=script&lang=js"
export * from "./LeaderboardInfo.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardInfo.vue?vue&type=style&index=0&id=1271a3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271a3da",
  null
  
)

export default component.exports